// const webhookUrl = "https://hooks.zapier.com/hooks/catch/229626/b1u4icm"; v01/22
// const webhookUrl = "https://hooks.zapier.com/hooks/catch/229626/baw2nml/"; v06/22
// const webhookUrl = "https://hooks.zapier.com/hooks/catch/229626/bn9ncm1/"; // v12/22
const webhookUrl = "https://hooks.zapier.com/hooks/catch/229626/3dhbxs3/"; // v06/23

function submit(data) {
  return new Promise((resolve, reject) => {
    fetch(webhookUrl, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default submit;
